import { render, staticRenderFns } from "./clientProfileEditCompanyKeyword.vue?vue&type=template&id=6f2f7dca&scoped=true"
import script from "./clientProfileEditCompanyKeyword.vue?vue&type=script&lang=js"
export * from "./clientProfileEditCompanyKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f7dca",
  null
  
)

export default component.exports